<template>
  <div class="row mt-4">
    <div class="col">
      <table class="table">
        <thead>
          <tr>
            <th>{{ __('channel.id') }}</th>
            <th>{{ __('channel.name') }}</th>
            <th>{{ __('channel.created_at') }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
        <tr v-for="channel in channels" :key="channel.id">
          <td><a href="#" v-on:click.prevent="newWindow(links[channel.id].embed, $event)">{{ channel.id }}</a> &nbsp;<span :class="getStatusBatchClass(channel.state)">{{ __('medialive.channel.' + channel.state)  }}</span></td>
          <td><a href="#" v-on:click.prevent="jump(links[channel.id].show, $event)">{{ channel.name }}</a></td>
          <td>{{ channel.created_at }}</td>
          <td>
            <a v-show="links[channel.id].enable_delete" href="#" v-on:click.prevent="confirm(links[channel.id].remove, $event)" class="btn btn-danger ml-1 btn-sm float-right">{{ __('button.delete') }}</a>
            <a v-show="!links[channel.id].is_running" href="#" v-on:click.prevent="jump(links[channel.id].edit, $event)" class="btn btn-secondary ml-1 btn-sm float-right">{{ __('button.edit') }}</a>
            <a v-show="links[channel.id].enable_publish" href="#" v-on:click.prevent="jump(links[channel.id].start, $event)" class="btn btn-primary ml-1 btn-sm float-right">{{ __('button.start') }}</a>
            <a v-show="links[channel.id].is_running" href="#" v-on:click.prevent="jump(links[channel.id].stop, $event)" class="btn btn-primary ml-1 btn-sm float-right">{{ __('button.stop') }}</a>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChannelList",
  data () {
    return {
      csrf_token: '',
      channels: [],
      links: [],
      updateMessageTimer : null,
      channel_empty: false
    }
  },
  async created () {
    console.log('created');
    this.fetchChannels();
  },
  mounted () {
    this.updateMessageTimer = setInterval(this.fetchChannels, 10000)
  },
  destroyed () {
    clearInterval(this.updateMessageTimer)
  },
  methods: {
    getStatusBatchClass (state) {
      let class_name = 'badge badge-secondary';
      switch (state) {
        case 'CREATING':
        case 'CREATE_FAILED':
        case 'RECOVERING':
        case 'DELETING':
        case 'DELETED':
        case 'UPDATING':
        case 'UPDATE_FAILED':
        case 'STARTING':
        case 'STOPPING':
          class_name = 'badge badge-warning';
          break;
        case 'RUNNING':
          class_name = 'badge badge-danger';
      }
      return class_name;
    },
    async fetchChannels () {
      console.log('fetchChannels');
      this.csrf_token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
      const response = await axios.get('/api/channels', { _token: this.csrf_token });
      this.channels = response.data.channels;
      this.links = response.data.links;
      this.channel_empty = (this.channels.length <= 0) ? true : false;
    },
    newWindow(link, event) {
      window.open(link, '_blank');
      return;
    },
    jump (link, event) {
      console.log('jump', link);
      window.location.href = link;
      return;
    },
    confirm (link, event) {
      if (confirm(this.__('I really delete this?'))) {
        window.location.href = link;
      }
      return false;
    }

  }
}
</script>